
    <div class="ramadan-banner">

        <div class="accessories">
            <img  class="img-responsive" src="assets/img/ramadan20/accessories.png" alt="">
        </div>

        <div class="content">
            <div class="logo">
                <img src="assets/img/ramadan20/ramadan-logo.svg" width="250" alt="">
            </div>
            <!--<h1>Ramadan Tournaments</h1>-->
            <div class="title">
                <p style=" color:#fde0c5;font-size: 14px; text-align: center">Get ready to join our 40+ tournaments for Ramadan, featuring 8 famous games,
                    and win exclusive prizes offered by our sponsors!</p>
                <p style="color:#fde0c5; font-size: 14px; font-family: proxima-nova-bold-webfont">#StayHome_PlaySafe</p>

                <!--<p style="color:#fde0c5; font-size: 14px;">The ultimate way to entertain yourself in Ramadan</p>-->
            </div>
            <div class="partners_logo">
                <div class="flex_block" style="justify-content: center; align-items: center">
                    <img class="hidden-xs" src="assets/img/ramadan20/pubg-logo.png" width="60" alt="">
                    <img class="hidden-xs" src="assets/img/ramadan20/smile-logo.png" width="60" alt="">
                </div>
                <div class="flex_block" style="justify-content: center; align-items: center; flex-flow: row wrap;">
                    <img class="hidden-sm hidden-md hidden-lg" src="assets/img/ramadan20/pubg-logo.png" width="50" alt="">
                    <img class="hidden-sm hidden-md hidden-lg" src="assets/img/ramadan20/smile-logo.png" width="50" alt="">
                    <img  src="assets/img/ramadan20/aorus-logo.png" width="100" alt="">
                    <img src="assets/img/ramadan20/intel-logo.svg" width="60" alt="">
                    <img src="assets/img/ramadan20/manlook-logo.svg" width="60" alt="">
                    <img src="assets/img/ramadan20/coco-logo.png" width="60" alt="">
                    <img src="assets/img/ramadan20/gc-logo.png" width="40" alt="">
                    <img src="assets/img/ramadan20/ah-logo.png" width="40" alt="">
                </div>
            </div>
        </div>
        <div class="pillar r  hidden-xs hidden-sm">
            <img class="img-responsive" src="assets/img/ramadan20/pillar.png" alt="">
        </div>
        <div class="pillar l hidden-xs">
            <img class="img-responsive" src="assets/img/ramadan20/pillar.png" alt="">
        </div>

        <!--<div class="content-gredient "></div>-->
    </div>

    <div class="wall">
        <div class="banner-footer"></div>


        <!--<div class="title">-->
        <!--&lt;!&ndash;<h1>{{language.select_game}}</h1>&ndash;&gt;-->
        <!--</div>-->


        <div class="row-container">
            <div class="switch-container">
                <div class="switch" id="switch">
                    <svg width="60px" height="120px" viewBox="124 -23 357 512" version="1.1"
                         xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="1482704683_light-switch" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                           transform="translate(124.000000, -23.000000)">
                            <g id="light-switch">
                                <g id="light-switch_1_">
                                    <rect id="Rectangle" fill="#FFFFFF" x="0" y="0" width="356" height="512"
                                          rx="71"></rect>
                                    <path d="M178.389,100.598 C188.275,100.598 196.362,92.51 196.362,82.633 C196.362,72.668 188.275,64.668 178.389,64.668 C168.424,64.668 160.336,72.668 160.336,82.633 C160.336,92.51 168.424,100.598 178.389,100.598 Z"
                                          id="Shape" fill="#EAEAEA"></path>
                                    <path d="M178.389,406.007 C168.424,406.007 160.336,413.998 160.336,423.972 C160.336,433.849 168.424,441.937 178.389,441.937 C188.275,441.937 196.362,433.849 196.362,423.972 C196.362,413.998 188.276,406.007 178.389,406.007 Z"
                                          id="Shape" fill="#EAEAEA"></path>
                                    <path d="M302.355,0 L53.896,0 C24.176,0 0,24.176 0,53.896 L0,458.105 C0,487.824 24.176,512 53.896,512 L302.356,512 C332.076,512 356.252,487.824 356.252,458.104 L356.252,53.896 C356.251,24.176 332.075,0 302.355,0 Z M338.286,458.104 C338.286,477.921 322.172,494.034 302.356,494.034 L53.896,494.034 C34.084,494.034 17.966,477.92 17.966,458.104 L17.966,53.896 C17.966,34.079 34.084,17.966 53.896,17.966 L302.356,17.966 C322.173,17.966 338.286,34.08 338.286,53.896 L338.286,458.104 Z"
                                          id="Shape" fill="#CDCDCD"></path>
                                    <polygon id="Shape" fill="#CCCCCC"
                                             points="131.686 284.742 131.686 353.366 223.574 353.366 223.574 284.742 223.574 148.3 131.686 148.3"></polygon>
                                    <rect id="Rectangle-2" class="switchnob" fill="#FAFAFA" x="148" y="166" width="60"
                                          height="75"></rect>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <p style="font-size:10px; padding:11px; text-align: center;">Turn the lights on and start selecting your game</p>
            </div>

            <perfect-scrollbar class="games-container">
                <div class="container">
                    <div class="flex_block" style="padding:10px;">
                        <div *ngFor="let game of games, let i=index" class="game-card" routerLink="../{{games[i][0]}}" routerLinkActive="active"

                             [ngStyle]="{'background-image': 'url(assets/img/games/'+games[i][0]+'/block.jpg)'}">
                            <div class="cover {{games[i][0]}}"></div>

                            <!--Light rope-->
                            <div class="lights vbox">
                                <svg width="100%" height="50px" viewBox="114 88 732 82" version="1.1"
                                     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <defs></defs>
                                    <filter id="glow" width="200%" height="200%" filterUnits="userSpaceOnUse">
                                        <feGaussianBlur stdDeviation="12.5" result="coloredBlur"/>
                                        <feMerge>
                                            <feMergeNode in="coloredBlur"/>
                                            <feMergeNode in="SourceGraphic"/>
                                        </feMerge>
                                    </filter>
                                    <g id="Light1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                       transform="translate(129.000000, 117.000000) rotate(9.000000) translate(-129.000000, -117.000000) translate(119.000000, 89.000000)">
                                        <ellipse class="light" id="Oval" fill="#FF3E3E" cx="10" cy="37.5" rx="10"
                                                 ry="18.5"></ellipse>
                                        <rect id="Rectangle" fill="#496E4C" x="2" y="-5.68434189e-14" width="16"
                                              height="22"
                                              rx="4"></rect>
                                    </g>
                                    <g id="Light1-Copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                       transform="translate(229.000000, 117.000000) rotate(-9.000000) translate(-229.000000, -117.000000) translate(219.000000, 89.000000)">
                                        <ellipse class="light" id="Oval" fill="#50F446" cx="10" cy="45" rx="15"
                                                 ry="25"></ellipse>
                                        <rect id="Rectangle" fill="#496E4C" x="2" y="4.26325641e-14" width="16"
                                              height="22"
                                              rx="4"></rect>
                                    </g>
                                    <g id="Light1-Copy-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                       transform="translate(329.000000, 117.000000) rotate(5.000000) translate(-329.000000, -117.000000) translate(319.000000, 89.000000)">
                                        <ellipse class="light" id="Oval" fill="#FF9F19" cx="10" cy="45" rx="15"
                                                 ry="25"></ellipse>
                                        <rect id="Rectangle" fill="#496E4C" x="2" y="-7.10542736e-15" width="16"
                                              height="22"
                                              rx="4"></rect>
                                    </g>
                                    <g id="Light1-Copy-3" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                       transform="translate(429.000000, 117.000000) rotate(-2.000000) translate(-429.000000, -117.000000) translate(419.000000, 89.000000)">
                                        <ellipse class="light" id="Oval" fill="#221DFF" cx="10" cy="45" rx="15"
                                                 ry="25"></ellipse>
                                        <rect id="Rectangle" fill="#496E4C" x="2" y="-1.42108547e-14" width="16"
                                              height="22"
                                              rx="4"></rect>
                                    </g>
                                    <g id="Light1-Copy-4" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                       transform="translate(529.000000, 117.000000) rotate(-9.000000) translate(-529.000000, -117.000000) translate(519.000000, 89.000000)">
                                        <ellipse class="light" id="Oval" fill="#FFFFFF" cx="10" cy="45" rx="15"
                                                 ry="25"></ellipse>
                                        <rect id="Rectangle" fill="#496E4C" x="2" y="2.84217094e-14" width="16"
                                              height="22"
                                              rx="4"></rect>
                                    </g>
                                    <g id="Light1-Copy-5" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                       transform="translate(629.000000, 117.000000) rotate(18.000000) translate(-629.000000, -117.000000) translate(619.000000, 89.000000)">
                                        <ellipse class="light" id="Oval" stroke="#F51F1F" fill="#FF3E3E" cx="10" cy="45"
                                                 rx="15" ry="25"></ellipse>
                                        <rect id="Rectangle" fill="#496E4C" x="2" y="-1.42108547e-14" width="16"
                                              height="22"
                                              rx="4"></rect>
                                    </g>
                                    <g id="Light1-Copy-7" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                       transform="translate(729.000000, 117.000000) rotate(3.000000) translate(-729.000000, -117.000000) translate(719.000000, 89.000000)">
                                        <ellipse class="light" id="Oval" fill="#50F346" cx="10" cy="45" rx="15"
                                                 ry="25"></ellipse>
                                        <rect id="Rectangle" fill="#496E4C" x="2" y="2.13162821e-14" width="16"
                                              height="22"
                                              rx="4"></rect>
                                    </g>
                                    <g id="Light1-Copy-6" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                       transform="translate(829.000000, 117.000000) rotate(-13.000000) translate(-829.000000, -117.000000) translate(819.000000, 89.000000)">
                                        <ellipse class="light" id="Oval" fill="#FF9F1A" cx="10" cy="45" rx="15"
                                                 ry="25"></ellipse>
                                        <rect id="Rectangle" fill="#496E4C" x="2" y="0" width="16" height="22"
                                              rx="4"></rect>
                                    </g>
                                    <path d="M137,94 C137,94 213.5,102 227,95.5 C240.5,89 319,89.0008917 330.5,91.5 C342,93.9991083 423.5,99.5 431,92.5 C438.5,85.5 511,99.5 529,91 C547,82.5 635.5,96.5 635.5,96.5 C635.5,96.5 720,104 735,97.5 C750,91 826,96.5 826,96.5"
                                          id="Path-2" stroke="#496E4C" stroke-width="1" fill="none"></path>
                                </svg>
                            </div>
                            <div class="logo">
                                <img src="assets/img/games/{{games[i][0]}}/logo.png" alt="">
                            </div>
                            <div class="footer">
                                <div class="flex_block column" style="flex-grow: 1">
                                    <h1>{{games[i][1]}}</h1>
                                    <p>{{games[i][2]}}</p>
                                </div>
                                <img src="assets/img/consoles/{{games[i][3]}}.svg" alt="">
                            </div>


                        </div>
                    </div>
                </div>
            </perfect-scrollbar>

        </div>


        <!--<div class="title">-->
        <!--<h1>{{language.covid_title}}</h1>-->
        <!--<p>{{language.covid_text}}</p>-->
        <!--</div>-->


    </div>

    <app-ramadan-covid19-advice></app-ramadan-covid19-advice>

